<template>

 <div class="mainMenus" >

  
    <div class="Contentframe" >
     
        <div class="leftmenu">
          <LeftMenus  :styles="styles" :active="active" :infoID="$route.query.infoID"></LeftMenus>
       </div>
 
        <div class="rightContent"> 
           <div >
            <iframe :src="htmlUrl" id="outerHTML" width='100%' 
              style="min-height:800px" scrolling="no" frameborder="0"  ></iframe> 
              <div class="downloadbox">
              <span>附件：{{announcement.oldFileName}}</span>
              <el-button   style="margin-left:50px" @click="downFile(announcement.filePath)"><span>点击下载</span></el-button>
              <span  style="padding-left:20px">下载次数:{{announcement.downTimes==null?0:announcement.downTimes}}</span>
             </div>
          </div>
        </div>
   </div>
   </div>
  
</template>

<script>
import LeftMenus from './../LeftMenus.vue'
export default {
  components:{LeftMenus},
created(){
    this.getAnnouncement()
},data(){
    return{
        announcement:[],
        htmlUrl:'',
        styles:[],
            active:[],
            infoList:[],
    }
},methods:{
    getAnnouncement(){
      this.active=this.$route.query.active
       this.styles=this.$route.query.styles   
        this.axios.post("/announcement/selectAnnouncement?announcementId="+ this.$route.query.announcementId)
         .then(resp => { 
                       if(resp.data.status == 1) {
                        console.log(resp.data.result)
                                this.announcement=resp.data.result[0]
                                console.log( this.announcement)
                                this.htmlUrl=this.$imagepath+this.announcement.htmpPath
                                }else {
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
    },downFile(data){
          const formData = new FormData()
      formData.append('filePath', data)
      formData.append('oldFileName', this.announcement.oldFileName)
          this.axios({
            url: "/announcement/downFile",   //后端地址
            method: "post",
            data:formData, //请求参数
            headers: {  
            'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
            },
            // contenType:'application/json',
            responseType: "blob"
          })
            .then(res => {
            
          const blob = new Blob([res.data], { type: 'application/octet-stream' });
          const fileName = this.announcement.oldFileName; 
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            console.log( elink.click())
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink); 
            this.selectData=false     
            this.axios.post("/announcement/updateTimes?announcementId="+ this.announcement.announcementId)
         .then(resp => { 
                       if(resp.data.status == 1) {
                        console.log(resp.data.result)
                              
                                }else {
                                       alert("出错")                          
                                }
                            }) 
                              
            })
        
    }
}
}
</script>

 <style scoped>

 .leftmenu
   {
     padding-left:15px;
       background:#0065bd;
     color:black;
     margin-top: 40px;
     margin-right: 20px;
     height:500px;
     width:20%;
     padding: 20px;
     box-shadow: 0px 0px 2px #ededed;
   }
  .rightContent{
  width: 80%;
  margin-left:50px;


}
 .mainMenus{
  width: 100%;
  height: 100%;
  margin: auto;
  display: flex;
}
.mainMenus{
  padding-left: 0px;
}

.Contentframe{
  width: 90%;
  margin: auto;
  display: flex;
  /* background:#cfcfcf */
 
}
.downloadbox{

  background:#f5f0f0;
  padding:20px
}

</style>


// WEBPACK FOOTER //
// src/components/work/bam/ShowAnnouncement.vue